import React, { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';

const FAQ = () => {
  return (
    <section id="faq" className="relative py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-5">
            <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
              Pertanyaan
            </span>
          </div>
          <h2 className="text-white font-bold text-4xl md:text-5xl leading-tight tracking-tight mb-5">
            Frequently Asked <span className="gold-gradient-text">Questions</span>
          </h2>
          <p className="text-neutral-400 text-lg">
            Temukan jawaban atas pertanyaan umum tentang layanan Werdi Media
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-[#0f0f0f] border border-white/[0.06] hover:border-[#D4A94F]/30 rounded-2xl px-6 btn-transition"
            >
              <AccordionTrigger className="text-left text-white font-semibold text-base py-5 hover:no-underline hover:text-[#E9C46A] btn-transition">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
